export default __webpack_public_path__ + "static/1546-c72ff2755f5462683bbfd0a8c74af9a6.gif";